<template>
    <div>
        <app-overlay-loader v-if="preloader" />
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog" :class="{ 'loading-opacity': preloader }">
            <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Currency</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 mb-3">
                               <app-input 
                                    type="text"
                                    v-model="inputs.Code"
                                    :placeholder="'Code'"
                                    :required="true"
                                    :disabled="is_view"
                                />
                            </div>
                            <div class="col-12 mb-3">
                                <app-input 
                                    type="text"
                                    v-model="inputs.Title"
                                    :placeholder="'Title'"
                                    :required="true"
                                    :disabled="is_view"
                                />
                            </div>
                            <div class="col-12">
                                <app-input 
                                    type="text"
                                    v-model="inputs.simbolo"
                                    :placeholder="'Symbol'"
                                    :required="true"
                                    :disabled="is_view"
                                />
                            </div>
                        </div>    
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit" :disabled="is_view">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { get_data_currency } from './api/api.js';

export default {
    name: "AddUnit",
    props: {
        currency_id : {
            type: Number,
            default: ''
        },
        is_view : {
            type : Boolean,
            default : false,
        },
        is_edit : {
            type : Boolean, 
            default : false,
        }
    },
    data() {
        return {
            preloader: false,
            inputs : {
                id : null,
                Code : null,
                Title : null,
                simbolo: null,  
            }
        };
    },

    methods: {
        validateForm(inputs) {
            if (!inputs.Code) {
                this.$toastr.e("Required Code");
                return false;
            }else if(!inputs.Title){
                this.$toastr.e("Required Title");
                return false;
            }else if(!inputs.simbolo){
                this.$toastr.e("Required Symbol");
                return false;
            }
            return true;
        },

        submit() {
            this.preloader = true;
            const inputs = {
                ...this.inputs,
            }

            if(!this.validateForm(inputs)) {
                this.preloader = false;
                return;
            }

            const fetch = this.is_edit ? 'update' : 'save';
            this.$emit(fetch, inputs);
        },

        async loadData() {
            this.preloader = true;
            this.preloader = false;
        },

        async loadDataCurrency(id) {
            const data = await get_data_currency(id);
            if (data) {
                this.inputs = {... data}
            }
        },
    },
    async mounted() {
        this.loadData();
        if (this.currency_id) {
            this.loadDataCurrency(this.currency_id);
        }
    },

    watch: {
        // Escuchamos el objeto 'inputs'
        inputs: {
            handler(newVal, oldVal) {
                // console.log("Se detectó un cambio en los inputs:");
                // console.log("Nuevo estado:", JSON.parse(JSON.stringify(newVal)));
            },
            deep: true // <--- Esto es lo que permite entrar a los objetos internos
        },
    },
};
</script>
  